import React, {Component} from 'react';

// import Custom Componenets
// import Breadcrumb from '../components/common/breadcrumb.component';
import BootstrapTable from 'react-bootstrap-table-next';
// import paginationFactory from 'react-bootstrap-table2-paginator';
// import paginationFactory, { PaginationProvider, PaginationTotalStandalone, PaginationListStandalone } from 'react-bootstrap-table2-paginator';
import Modal from 'react-responsive-modal';
import { Button, Form, FormGroup, Label, Col } from 'reactstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import Select from 'react-select';

// import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';

// koneksi
import {Post, Get, Delete, ID_DESA, JENIS_DUSUN, JENIS_DESA} from '../function/Koneksi';

// css files
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
// import Keldes from './keldes';



const id_keldes = ID_DESA;

const frmDef = {
    uuid: '',
    nama  : '',
    detail  : '',
}
class BasicTable extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            pagination: [],
            status: {
                form:false,
                btnForm:false,
                btnAksi:false
            },
            awal: "",
            sebelum: "",
            hal: [],
            setelah: "",
            akhir: "",
            dt:frmDef,
						loading: false,
            // ============== Select 2 ==============
            frmTingkat: [],
            tingkatStat: [],
            frmDetail: [],
            detailStat: [],
            judul:"Tambah Jabatan Perangkat",
            alert:null,
            show: false,
            basicTitle:'',
            basicType:"default",
            pesanAlert:'',

            // FItur Kelurahan
			isKelurahan: false,
        };
    }
    
    // ================== Sweet Alert ==================
    closeAlert = () => {
        this.setState({
            show: false
        });
    }

    onRecieveInput = (value) => {
        this.setState({
            alert: (
                <SweetAlert success title="Nice!" onConfirm={this.hideAlert}>
                    You wrote: {value}
                </SweetAlert>
            )
        });
    }

    hideAlert = () => {
        this.setState({
            alert: null
        });
    }

    // =================================================

    // ================== Ambil data dari db untuk table ==================
    fetch = (params = {}) => 
    {    
				this.setState({ loading: true })
        let link = "";
        // let where = [];
        // if (params.where)
        // {
        //     where = params.where;
        // }
        if (params.page)
        {
            switch(params.page)
            {
                case '>>': link = "?page="+(Math.ceil(this.state.pagination.total / this.state.pagination.per_page));break;
                case '>': link = "?page="+(parseInt(this.state.pagination.current_page) + 1);break;
                case '<': link = "?page="+(parseInt(this.state.pagination.current_page) - 1);break;
                case '<<': link = "?page=1";break;
                default: link = "?page="+params.page;break;
            }
        }
        Get('jabatan-perangkat'+link, null, (dtkat) => {
            this.setState({data:dtkat.results.data, pagination:dtkat.results, loading: false});
            this.pagination(dtkat.results);
        });
    }

    // Pagination
    pagination = (data) => {
        // const data = this.state.pagination;
        //console.log(data);
        let awal = "";
        let hal = [];
        let sebelum = "";
        let setelah = "";
        let akhir = "";
        if (data.total > 0)
        {
            let start = 1;
            let end = 5;
            let n = 0;
            let p = 0;
            if (data.current_page <= 3)
            {   
                start = 1;
                end = 5;
                if (data.last_page > data.current_page)
                {
                    n = data.current_page + 1;
                }
            }
            else 
            {
                p = data.current_page - 1;
                n = data.current_page + 1;
                start = data.current_page - 2;
                end = data.current_page + 2;
            }
            if (end >= data.last_page - 2)
            {
                p = data.current_page - 1;
                if (start >= 5)
                {
                    start = data.last_page - 4;
                }
                end = data.last_page;
            }

            for (let i=start;i<=end;i++) 
            {
                let warna = "primary-custom";
                if (i === data.current_page)
                {
                    warna = "danger"
                }
                hal.push(<a href={() => false} onClick={()=>this.fetch({page:i})} className={"btn btn-"+warna+" btn-square btn-sm pr-3 pl-3 pt-2 pb-2"}>{i}</a>)
            }
            if (p > 0)
            {
                sebelum = (<a href={() => false} onClick={()=>this.fetch({page:p})} className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2">{"<"}</a>)
            }
            if (n > 0)
            {
                setelah = (<a href={() => false} onClick={()=>this.fetch({page:n})} className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2">{">"}</a>)
            }
            awal = (<a href={() => false} onClick={()=>this.fetch({page:1})} className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2">{"<<"}</a>)
            akhir = (<a href={() => false} onClick={()=>this.fetch({page:data.last_page})} className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2">{">>"}</a>)
        }
        this.setState({awal,sebelum,hal,setelah,akhir});
    }
    // Cari Data Table
    cariData = e => {
        if (e.key === "Enter")
        {
            let addJabatanPerangkat = {
                nama : e.target.value,
            };
            Post('jabatan-perangkat',null, addJabatanPerangkat, (data) => {
                this.setState({data:data.data.results.data, pagination:data.data.results});
            });
        }
    }

    // ========================================================================

    // ================== simpan data ==================
    simpan = e => {
        e.preventDefault();
        this.setState({
            status:{
                ...this.state.status,
                btnForm: true,
            },
        })
        this.forceUpdate();
        let addJabatanPerangkat = {
            uuid : document.getElementById("uuid").value,
            nama : document.getElementById("nama").value,
            id_keldes : id_keldes,
            tingkat_perangkat : this.state.tingkatStat.value,
        };
        
        let psn = '';
        let resstat = 204;
        let metode = "create";
        if (addJabatanPerangkat.uuid === '')
        {
            psn = "Tambah"; 
            resstat = 201;
            addJabatanPerangkat.uuid = null;
            
        } 
        else 
        {
            psn = "Ubah"; 
            resstat = 200;
            metode = "update";
        }
        Post('jabatan-perangkat/'+metode,addJabatanPerangkat.uuid,addJabatanPerangkat, (res) => {
            this.setState({
                status:{
                    ...this.state.status,
                    btnForm: false,
                    form: false,
                },
            })
            this.forceUpdate();
            if (res.status === resstat)
            {
                this.setState({ show: true, basicType:'success', basicTitle:'Data Jabatan Perangkat', pesanAlert:'Berhasil '+psn+' Data' });
                this.tutupForm();
            }
            else
            {
                this.setState({ show: true, basicType:'danger', basicTitle:'Data Jabatan Perangkat', pesanAlert:'Gagal '+psn+' Data' });
            }
            this.componentDidMount();
        });
    }
    // ========================================================================
    
    // ============================== Ubah Data ===============================
    
    ubahData = (data) => {
        this.setState({
            status:{
                ...this.state.status,
                btnAksi: true,
            },
            judul: "Ubah Jabatan Perangkat",
        })
        this.forceUpdate();
        // Get('jabatan-perangkat/find',id, (data) => {
            // console.log("Data Edit")
            // console.log(data)
            this.setState({
                dt:data, 
                status:{
                    ...this.state.status,
                    btnAksi: false,
                },
                tingkatStat:{value:data.tingkat_perangkat,label:data.tingkat_perangkat.trim().toLowerCase().replace(/\w\S*/g, (w) => (w.replace(/^\w/, (c) => c.toUpperCase())))}
            });
            this.bukaForm();
        // });
    }
    // ========================================================================
    // ============================= Hapus Data ===============================
    konfirmHapus = (id) => {
        this.setState({
            alert: (
                <SweetAlert
                    showCancel
                    confirmBtnText="Hapus"
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="success"
                    type="danger"
                    title="Yakin ingin hapus data ?"
                    onCancel={this.hideAlert}
                    onConfirm={()=> this.hapusData(id)}
                >
                    Proses ini tidak dapat dibatalkan!
                </SweetAlert>
            )
        });
    }

    hapusData = (id) => {
        this.hideAlert();
        let psn = "Hapus";
        Delete('jabatan-perangkat/delete', id, (res) => {
            if (res === 200)
            {
                this.setState({ show: true, basicType:'success', basicTitle:'Data Jabatan Perangkat', pesanAlert:'Berhasil '+psn+' Data' });
            }
            else
            {
                this.setState({ show: true, basicType:'danger', basicTitle:'Data Jabatan Perangkat', pesanAlert:'Gagal '+psn+' Data' });
            }
            this.componentDidMount();
        })
    }
    // ========================================================================

    bukaForm = () => {
        this.setState({
            status:{
                ...this.state.status,
                form: true,
            },
        })
        this.forceUpdate();
    }

    tutupForm = () => {
        this.setState({
            status:{
                ...this.state.status,
                form: false,
            },
            tingkatStat: [],
        })
        this.forceUpdate();
    }

    tombolAksi = (cell, row) => {
        return (
            <>
                <Button  size="xs" color="success" className="btn-icon" onClick={() => this.ubahData(row)} disabled={this.state.status.btnAksi}><i className="fa fa-pencil"></i></Button> 
            </>
        )
    }

    getDetail = (e, sel) => 
    {
        this.changeSelectValue(e,sel);
        if (e)
        {
            switch(e.value)
            {
                case 'desa': 
                Get('keldes/find',id_keldes,(dt) => {
                    this.setState({frmDetail:[{value:dt.results.id, label:dt.results.nama}]});
                });break;
                case 'dusun': 
                Get('dusun/kel/'+id_keldes+"/list",null,(data) => {
                    let frmDetail = [];
                    data.results.forEach((dt) => {
                        frmDetail.push({value:dt.id, label:dt.nama});
                    });
                    this.setState({frmDetail});
                });break;
                case 'rw': 
                Get('rw/kel/'+id_keldes+"/list",null,(data) => {
                    let frmDetail = [];
                    data.results.forEach((dt) => {
                        frmDetail.push({value:dt.id, label:dt.nama});
                    });
                    this.setState({frmDetail});
                });break;
                case 'rt': 
                Get('rt/kel/'+id_keldes+"/list",null,(data) => {
                    let frmDetail = [];
                    data.results.forEach((dt) => {
                        frmDetail.push({value:dt.id, label:'RT.'+dt.nama+' Rw.'+dt.data_rw.nama});
                    });
                    this.setState({frmDetail});
                });break;
                default:
                    // no default
                    break;
            }
        }
        else 
        {
            this.setState({tingkatStat:[], detailStat:[]});
        }
    }

    changeSelectValue = (e,sel) =>
    {
        if (e){
            switch(sel)
            {
                case 'tingkat': this.setState({tingkatStat:e, detailStat:[]}); break;
                case 'detail': this.setState({detailStat:e}); break;
                default:
                    // no default
                    break;
            }
        }
        else 
        {
            switch(sel)
            {
                case 'tingkat': 
                    this.setState({tingkatStat:[], detailStat:[]}); 
                    break;
                case 'detail': 
                    this.setState({detailStat:[]}); 
                    break;
                default:
                    // no default
                    break;
            }
        }
        this.setState({
            status:{
                ...this.state.status,
                select: false,
            },
        })
        this.forceUpdate();
    }

    componentDidMount() {
        this.fetch({page:null,where:[]});
        if (JENIS_DESA.toLowerCase() === 'kelurahan') {
			this.setState({ 
                isKelurahan: true,
                frmTingkat:[
                    {value:JENIS_DESA.toLowerCase(), label:JENIS_DESA},
                    {value:"rw",label:"RW"},
                    {value:"rt",label:"RT"}
                ]
            });
        }
        else{
            this.setState({frmTingkat:[{value:JENIS_DESA.toLowerCase(), label:JENIS_DESA},{value:JENIS_DUSUN.toLowerCase(), label:JENIS_DUSUN},{value:"rw",label:"RW"},{value:"rt",label:"RT"}]});
        }
    }

    render() {
        // var size = Math.ceil(this.state.pagination.total / this.state.pagination.per_page);
        // var size = this.state.pagination.total;
        // var from = this.state.pagination.from;
        // var page = this.state.pagination.current;
        // var to = this.state.pagination.to;
        // var total = this.state.pagination.total;
        var data = this.state.data;
        const frmDef = {
            uuid: '',
            nama  : '',
            detail  : '',
        }
        
        // const { SearchBar } = Search;
        const columns = [
            {
                dataField: "no",
                text: "No",
                headerAlign: 'center',
								align: 'center',
								style: {
									width: '80px'
								},
                formatter: (key, obj, index) =>{          
                    let current_pagenum = this.state.pagination.current_page;
                    let total_records_per_page = this.state.pagination.per_page;
                    let row_index = (index+1);
                    let serial_num = ((total_records_per_page*(current_pagenum-1))+row_index);
                    return serial_num; 
                },
            },
            {
                dataField: 'nama',
                text: 'Nama Jabatan',
								headerAlign: 'center',
								align: 'center',
                sort: true
            },
            {
                dataField: 'aksi',
                text: 'Aksi',
                headerAlign: 'center',
								align: 'center',
								style: {
									width: '130px'
								},
                formatter: this.tombolAksi,
            },
        ];

        // const defaultSorted = [{
        //     dataField: 'nama',
        //     order: 'asc'
        // }];

        // const pageButtonRenderer = ({
        //                                 page,
        //                                 active,
        //                                 disable,
        //                                 title,
        //                                 onPageChange
        //                             }) => {
        //     const handleClick = (e) => {
        //         e.preventDefault();
        //         this.fetch({where:[],page:page});
        //     };
        //     var classname = '';
        //         classname = 'btn btn-success';
        //     return (
        //         <li className="page-item pl-1" key={page}>
        //             <a href="#" onClick={ handleClick } className={ classname }>{ page }</a>
        //         </li>
        //     );
        // };

        // const options = {
        //     alwaysShowAllBtns:true,
        //     pageButtonRenderer,
        //     // custom: true,
        //     paginationTotalRenderer: () => (
        //         <span className="react-bootstrap-table-pagination-total">
        //             Showing { from } to { to } of { total } Results
        //         </span>
        //     ),
        //     paginationSize: size, 
        //     totalSize: total
        //   };

        return (
            <div>
                {/* <Breadcrumb title="Data Jabatan Perangkat" parent="Admin"/> */}
                <SweetAlert
                    show={this.state.show}
                    type={this.state.basicType}
                    title={this.state.basicTitle}
                    confirmBtnBsStyle="success"
                    onConfirm={this.closeAlert}
                >
                    {this.state.pesanAlert}
                </SweetAlert>

                {this.state.alert}

                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card mb-0">
                                <div className="card-header">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            {/* <h5>Data Jabatan Perangkat</h5> */}
                                            {/* <span>DataTables has most features enabled by default, so all you need to do to use it with your own tables is to call the construction function:<code>$().DataTable();</code>.</span><span>Searching, ordering and paging goodness will be immediately added to the table, as shown in this example.</span> */}
                                        </div>
                                        <div className="col-sm-6 text-right">
                                            <Button  size="sm" color="success" className="btn-square" onClick={()=> {this.setState({judul:"Tambah Jabatan Perangkat", dt:frmDef});this.bukaForm()}}>Tambah Data</Button>                                            
                                        </div>
                                    </div>
                                </div>
                                <div className="card-body datatable-react">
                                    <div className="row">
                                        <div className="col-2">
                                        &nbsp;
                                        </div>
                                        <div className="col-8">
																					{this.state.loading ? (
																						<div className="row">
																							<div className="col-sm-12" align="center">
																								<img
																									alt="loading"
																									src={require("../assets/images/tes-loading.gif")}
																									style={{
																										borderRadius: "10px",
																										width: '100px'
																									}} />
																							</div>
																						</div>
																					) : data.length > 0 ? (
																						<>
                                            <BootstrapTable
                                                keyField="id"
                                                data={ data }
                                                columns={ columns }
                                                />
                                            <div className="pull-right text-white">
                                                {this.state.awal}{this.state.sebelum}{this.state.hal.map(dt=> { return dt})}{this.state.setelah}{this.state.akhir}
                                            </div>
																						</>
																					) : (
																						<h6 className="text-center mb-2 mt-2">Belum ada data</h6>
																					)}
                                        </div>
                                    </div>
                                    <div className="col-2"> 
                                        &nbsp;
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <br/>
                <Modal open={this.state.status.form} onClose={this.tutupForm} closeOnEsc={false} closeOnOverlayClick={false}>
                    <Form className="theme-form" onSubmit={this.simpan}>
                        <div className="modal-header">
                            <h5 className="modal-title">{this.state.judul}</h5>
                        </div>
                        <div className="modal-body">
                            <input className="form-control" id="uuid" type="hidden" placeholder="JabatanPerangkat" defaultValue={this.state.dt.uuid}/>
                            <FormGroup className="row">
                                <Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Nama Jabatan</Label>
                                <Col sm='9'>
                                    <input className="form-control" id="nama" type="text" placeholder="Nama Jabatan" defaultValue={this.state.dt.nama}/>
                                </Col>
                            </FormGroup>
                            <FormGroup className="row">
                                <Label className="col-sm-3 col-form-label" htmlFor="inputEmail3">Tingkat</Label>
                                <Col sm='9'>
                                    <Select
                                        isDisabled={this.state.status.select}
                                        classNamePrefix="select"
                                        onChange={((e)=>{ this.getDetail(e,'tingkat')})}
                                        defaultValue={this.state.tingkatStat} 
                                        value={this.state.tingkatStat} 
                                        name="Tingkat"
                                        options={this.state.frmTingkat}
                                        placeholder="Pilih Tingkat"
                                        isClearable
                                        />
                                </Col>
                            </FormGroup>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-warning" disabled={this.state.status.btnForm} onClick={this.tutupForm}>Tutup</button>
                            <button type="submit" className="btn btn-success" disabled={this.state.status.btnForm} onClick={this.simpan}>Simpan</button>
                        </div>
                    </Form>
                </Modal>
            </div>
        )
    }
}


export default BasicTable;
